import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { GlobalStyle, Router, Favicon } from '@phishtool/ui';
import WebsiteGlobalStyle from '~styles/global-style';
import Header from '~components/header';
import Footer from '~components/footer';
import Page from '~components/page';
import routes from './router/routes';
const Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "-10qhscn" }) `
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
const App = () => (_jsxs(Wrapper, { children: [_jsx(Favicon, {}), _jsx(GlobalStyle, {}), _jsx(WebsiteGlobalStyle, {}), _jsx(Header, {}), _jsx(Page, { children: _jsx(Router, { routes: routes, titlePrefix: "PhishTool" }) }), _jsx(Footer, {}), _jsx("div", { id: "portal" })] }));
export default App;
